<div class="iss-not-found-page-up"></div>
<div class="iss-not-found-page-center">
  <div class="iss-not-found-page-title">Upps...</div>
  <div class="iss-not-found-page-msg">It seems like the page does not exist.</div>
  <button tuiButton [routerLink]="['/']">Go home</button>
</div>
<div class="iss-not-found-page-down"></div>
